import { useNavigate } from "react-router-dom";
import useTours from "./useTours";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import { useEffect, useRef, useState } from "react";
import { CUSTOM_OFFER } from "../../../routes";

export default function useTourDetails() {
    const { exercises, navigateToTourSale, loading, exerciseName, exerciseDescription, saleStepId } = useTours();
    const navigate = useNavigate();
    const customOffers = useSelector((state: State) => state.stepSaleConfig.customOffers);
    const [isExpanded, setIsExpanded] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const articleRef = useRef<HTMLDivElement>(null);
  
    // Znajdź saleStep, aby sprawdzić czy pochodzi z CustomOffer
    const isFromCustomOffer = !!saleStepId;
  
    // Sprawdź czy tekst wymaga przycisku "Pokaż więcej"
    useEffect(() => {
      const MAX_HEIGHT = 66; // ~3 linie
      const timers: NodeJS.Timeout[] = [];
  
      const checkHeight = () => {
        if (articleRef.current) {
          const needsExpansion = articleRef.current.scrollHeight > MAX_HEIGHT;
          setShowButton(needsExpansion);
        }
      };
  
      // Sprawdź kilka razy z rosnącymi odstępami, aby złapać moment gdy HTML się w pełni wyrenderuje
      timers.push(setTimeout(checkHeight, 50));
      timers.push(setTimeout(checkHeight, 150));
      timers.push(setTimeout(checkHeight, 300));
  
      return () => {
        timers.forEach((timer) => clearTimeout(timer));
      };
    }, [exerciseDescription]);
  
    // Funkcja nawigacji, która obsługuje powrót do CustomOffer
    const handleBack = () => {
      if (isFromCustomOffer) {
        // Znajdź offerId dla danego saleStepId
        let foundOfferId = "";
        customOffers.forEach((offer) => {
          if (offer.saleSteps.some((step) => step.id === saleStepId)) {
            foundOfferId = offer.stepId;
          }
        });
  
        if (foundOfferId) {
          // Nawiguj z powrotem do CustomOffer z odpowiednim offerId
          navigate(`${CUSTOM_OFFER}?offerId=${foundOfferId}`);
        } else {
          // Awaryjnie nawiguj do głównej strony TourSale
          navigateToTourSale();
        }
      } else {
        // Standardowa nawigacja dla zwykłego TourSale
        navigateToTourSale();
      }
    };
    
    return {
        isExpanded,
        setIsExpanded,
        showButton,
        setShowButton,
        articleRef,
        handleBack,
        exerciseName,
        exerciseDescription,
        exercises,
        loading,
    }
}